import { api, auth } from '@/f1/service';
import codes from '@/f1/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import reg from '@/f1/reg'
import QrcodeVue from 'qrcode.vue'
import qrcode from '@chenfengyuan/vue-qrcode';
import speakeasy from 'speakeasy';
import QRCode from 'qrcode';
import Language from './language';


const _i18n_data = {
  removeOTP1: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  },
  removeOTP2: {
    EN : () => `OTP Removed!.`,
    KO : () => `OTP를 지웠습니다.`,
  },
  save1: {
    EN : () => `Nickname required.`,
    KO : () => `이름을 입력하세요.`,
  },
  save2: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  },
  save3: {
    EN : () => `Password and Retype Password doesn\' match.`,
    KO : () => `새로입력한 비밀번호가 다릅니다.`,
  },
  save4: {
    EN : (msg) => `Please check password policy [${msg}].`,
    KO : (msg) => `비밀번호 정책을 확인하세요. [${msg}].`,
  },
  save5: {
    EN : () => `check password typing alphabet.`,
    KO : () => `비밀번호에 대소문자가 포함되는지 확인하세요.`,
  },
  save6: {
    EN : () => `check password typing spacial.`,
    KO : () => `비밀번호에 특수문자가 포함되는지 확인하세요.`,
  },
  save7: {
    EN : () => `check password typing number.`,
    KO : () => `비밀번호에 숫자가 포함되는지 확인하세요.`,
  },
  save8: {
    EN : () => `password length more then  + ${this.password_meter.min_length}`,
    KO : () => `비밀번호를 입력하세요.`,
  },
  save9: {
    EN : () => `require group info.`,
    KO : () => `그룹정보를 확인하세요.`,
  },
  save10: {
    EN : () => `otp update failed.`,
    KO : () => `OTP정보 저장에 실패하였습니다.`,
  },
  save11: {
    EN : () => `OTP_Updated.`,
    KO : () => `OTP 업데이트.`,
  },
  save12: {
    EN : () => `update failed.`,
    KO : () => `저장에 실패하였습니다..`,
  },
  save13: {
    EN : () => `Updated.`,
    KO : () => `저장완료.`,
  },
  get1: {
    EN : () => `copyed username :D.`,
    KO : () => `복사 완료.`,
  },
};

export default {
  computed: { i18n_data() { return _i18n_data; } }, // i18n 메세지 변환용.
  components: {  qrcode,QrcodeVue, QRCode, cSwitch, vSelect, Language},
  data : () => ({
    confirm: false, add: false, lock: true, group_list: undefined,urlurl : '', toggleOtp : false,otp_model : {},
    size: 300, qrcode : '',
    model : { group : { groupname : '' } },
    codes : codes,
    region : {
      language : codes.language_default,
      country : codes.country_default,
      timezone : codes.timezone_default
    },
    password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false, min_length : 10  },
    group_password_policy : {},
    pass : { new : '', old : '' },
  }),
  methods: {
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    async removeOTP(){
      try {
        if(!(this.pass.old || '').trim()) { return this.$toastr.e(_i18n_data['removeOTP1'][this.LangStatus] || 'Password required.'); }
        let password = forge.sha256.create().update(this.pass.old).digest().toHex();
        let p = { password : password, username : this.model.username }
        await api.auth.otpUnregister(p)
        this.$toastr.i(_i18n_data['removeOTP2'][this.LangStatus] || 'OTP Removed!');
        this.cancel();
      } catch(e) { this.$toastr.e(e.data.message); console.info(e) }
    },
    async genOtp(){
      // if(!this.toggleOtp || this.qrcode) { return }
      try {
        console.log("gen", "otp")
        let key = (await api.auth.otpGen({})).otpkey;
        let address = speakeasy.otpauthURL({ issuser : 'f1security', encoding: 'base32', digits : 6, period : 30, algorithm : 'sha1', secret: key, label: `F1 Secaas:${this.model.username}`});
        this.qrcode = await QRCode.toDataURL(encodeURI(address))
        this.toggleOtp = true;
        this.model.otpkey = key;
      } catch (e) { console.error(e) }
    },
    cancel() { this.lock = false; this.qrcode = ''; this.$router.replace({ name: 'profile' }); },
    edit() { this.$router.replace({ name: 'profile', params: { tag: 'edit' }}); },
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.pass.new && reg.reg_number.test(this.pass.new) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.pass.new && reg.reg_alphabat_upper.test(this.pass.new) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.pass.new && reg.reg_alphabat_lower.test(this.pass.new) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.pass.new && reg.reg_spacial.test(this.pass.new) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.pass.new && this.pass.new.length >= this.password_meter.min_length) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    async save() {
      if(!(this.model.nickname || '').trim()) { return this.$toastr.e(_i18n_data['save1'][this.LangStatus] || 'Nickname required.'); }
      if(!(this.pass.old || '').trim()) { return this.$toastr.e(_i18n_data['save2'][this.LangStatus] || 'Password required.'); }
      if(this.pass.new && this.pass.new != this.pass.repeat) { return this.$toastr.e(_i18n_data['save3'][this.LangStatus] || 'Password and Retype Password doesn\' match.'); }

      try {
        // var patt_4num1 = /(\w)\1\1\1/; // 같은 영문자&숫자 연속 4번 정규식
        // var patt_4num2 = /([\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"])\1\1\1/; // 같은 특수문자 연속 4번 정규식
        // var patt_4num3 = /([가-힣ㄱ-ㅎㅏ-ㅣ\x20])\1\1\1/; // 같은 한글 연속 4번 정규식
        // var patt_cont = /(0123)|(1234)|(2345)|(3456)|(4567)|(5678)|(6789)|(7890)/; // 연속된 숫자 정규식
        // if(patt_4num1.test(this.pass.new) || patt_4num2.test(this.pass.new) || patt_4num3.test(this.pass.new) || patt_cont.test(this.pass.new)){
        //   return this.$toastr.e("You cannot use consecutive characters or numbers")
        // }
        this.otp_model.password = this.model.password;
        this.otp_model.otp_key = this.model.otpkey;
        this.otp_model.otp_pin = this.model.otp_code;

        // let region = {};
        this.model.country = this.region.country.value
        this.model.timezone = this.region.timezone.value

        // 그룹의 패스워드 정책 확인
        let policy_count = -3
        if(this.model.group.security_policy && this.model.group.security_policy.password_use_number) { policy_count +=1 }
        if(this.model.group.security_policy && this.model.group.security_policy.password_use_spacial) { policy_count +=1 }
        if(this.model.group.security_policy && this.model.group.security_policy.password_use_alphabet) { policy_count +=1 }

        // 그룹 정책에서 최소한의 정책이 없을 경우, 시스템 정책을 따른다
        if(this.pass.new) {
          if(policy_count >= 0) {
            var rs = this.password_policy('all')
            if(rs.is_error) {
              var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
              return this.$toastr.e(_i18n_data['save4'][this.LangStatus] || `Please check password policy [${msg}]`);
            }
          } else {
            if(this.model.group && this.model.group.security_policy) {
              if(this.model.group.security_policy.password_use_alphabet && (!this.password_policy('uppercase') && !this.password_policy('lowercase'))) { return this.$toastr.e(_i18n_data['save5'][this.LangStatus] || "check password typing alphabet") }
              if(this.model.group.security_policy.password_use_spacial && !this.password_policy('spacial')) { return this.$toastr.e(_i18n_data['save6'][this.LangStatus] || "check password typing spacial") }
              if(this.model.group.security_policy.password_use_number && !this.password_policy('number')) { return this.$toastr.e(_i18n_data['save7'][this.LangStatus] || "check password typing number") }
              if(this.model.group.security_policy.password_min_len > 0 && !this.password_policy('length')) { return this.$toastr.e(_i18n_data['save8'][this.LangStatus] || "password length more then " + this.password_meter.min_length) }
            } else { return this.$toastr.e(_i18n_data['save9'][this.LangStatus] || "require group info") }
          }
          // 새로운 패스워드 세팅
          this.model.new_password = forge.sha256.create().update(this.pass.new).digest().toHex();
        }
        // console.log(this.model.group.security_policy, policy_count)
        if(this.model.otpkey){
          let rs = await api.auth.otpRegister(this.otp_model)
          if(rs.error) { return this.$toastr.e(_i18n_data['save10'][this.LangStatus] || "otp update failed") }
          this.$toastr.s(_i18n_data['save11'][this.LangStatus] || 'OTP_Updated');
          this.qrcode = '';
        }

        this.model.password = forge.sha256.create().update(this.pass.old).digest().toHex();
        let result = await api.auth.update(this.model);
        if(result.error) { return this.$toastr.e(_i18n_data['save12'][this.LangStatus] || "update failed") }
        this.$toastr.s(_i18n_data['save13'][this.LangStatus] || 'Updated'); this.$emit('refresh');
        this.cancel();
        this.lock = true;


      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
    async get({ id, tag } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; this.model = { is_use: true, is_active: true }; return; }
      else { this.add = false; }
      this.lock = (tag !== 'edit');
      try {
        let profile = await api.auth.get(auth.profile)
        this.model = Object.assign({ group: {} }, this.model,  profile);
        this.otp_model.otp_key = this.model.otpkey;
        this.model.otpkey != '' ? this.toggleOtp = true : this.toggleOtp = false;

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        this.password_meter.min_length = this.model.group.security_policy.password_min_len < this.password_meter.min_length ? this.password_meter.min_length : this.model.group.security_policy.password_min_len


      }catch(e) { this.$toastr.e(e); }

      try {
        if(location.hostname != "console.f1secaas.co.kr") { return }
        var copyText = document.getElementById("ph_username");
        copyText.select();
        if(document.execCommand("copy")) { this.$toastr.i(_i18n_data['get1'][this.LangStatus] || "copyed username :D") }
      } catch (e) { console.debug(e) }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from.path) } },
  created() { console.log('[vue] profile', 'created'); },
  destroyed() { console.log('[vue] profile', 'destroyed'); },
  mounted() { console.log('[vue] profile', 'mounted'); this.get(this.$route.params); },
}
